import { RichText, Text, Image } from '@sitecore-jss/sitecore-jss-react';
import React, { useEffect, useState } from 'react';
import CustomLink from '../Common/CustomLink';

const SubcriptionPlans = (props) => {
  useEffect(() => {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, []);
  return (
    <>
      <section className="value_subcription_plans sec_padding_cm">
        <div className="subcription_plans_inner">
          <div className="cus-container">
            <div className="subcription_plans_mb">
              <div className="invest_by_cat_header">
                <h2 className="section-heading heading-flex text-center">
                  <span className="">
                    {}
                    <RichText field={props?.fields?.heading} />
                  </span>
                </h2>
              </div>
              <div className="subscription_plans_grid">
                <div className="value_rowws">
                  {props?.fields?.plans?.map((item, index) => {
                    const IsPopular = item?.fields?.IsPopular?.value;
                    const CTALink = item?.fields?.CTALink?.value;
                    return (
                      <>
                        <div className={`plans_col ${IsPopular ? 'popularClubCard' : ''}`}>
                          {IsPopular ? (
                            <span className="pop_patch_yellow">
                              <img
                                className="polupar_plan_patch"
                                src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/category/popularArrow--img.png"
                                width="100%"
                                height="100%"
                                alt="Value Subscription"
                              />
                            </span>
                          ) : null}
                          <div className="club_card">
                            <div className="card_heading_wrap">
                              <div className="heading-title">
                                <div className="number-text">{index + 1}</div>
                                <h3 className="value_card_text">
                                  <Text field={item?.fields?.Heading} />
                                </h3>
                              </div>
                              <div className="clubCardSubheading">
                                <div className="club_card_sub_heading">
                                  <RichText field={item?.fields?.SubHeading} />
                                </div>
                                <p className="paragraph-p1">
                                  <RichText field={item?.fields?.Description} />
                                </p>
                              </div>
                              <RichText field={item?.fields?.Value} />
                            </div>
                            <div className="plan_pointers">
                              <RichText field={item?.fields?.Content} />
                            </div>
                            <div className="subscription_button">
                            {CTALink &&
                              <CustomLink
                                className="know_more_about-us articles-btn order_button"
                                field={CTALink}
                              />
                            }
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SubcriptionPlans;
